<section>
  <h2>{{ titleText }}</h2>
  <p-messages key="lePartnerFormMsg" [closable]="true"></p-messages>
  <ness-lepartner-search-user-form *ngIf="isEventForm" [agencyIdToSearch]="eventAgencyId" (onSelectedUser)="onSelectedUser($event)"></ness-lepartner-search-user-form>
  <div class="card my-3">
    <div class="card-body">
      <div class="card-title"><h3>User general information</h3></div>
      <form [formGroup]="lePartnerInputForm" class="font-size-sm">
        <div class="row row-cols-lg-3 gy-2 gx-3 align-items-start mb-2">
          <div class="col-12">
            <label for="FirstName" class="form-label required-field">First Name</label>
            <input id="FirstName" type="text" required formControlName="FirstName" class="form-control form-control-sm" aria-label="First Name" maxlength="50" />
            <div class="invalid-feedback">
              Please provide the first name.
            </div>
          </div>
          <div class="col-12">
            <label for="MiddleName" class="form-label">Middle Name</label>
            <input id="MiddleName" type="text" formControlName="MiddleName" class="form-control form-control-sm" aria-label="Middle Name" maxlength="50" />
          </div>
          <div class="col-12">
            <label for="LastName" class="form-label required-field">Last Name</label>
            <input id="LastName" type="text" required formControlName="LastName" class="form-control form-control-sm" aria-label="Last Name" maxlength="50" />
            <div class="invalid-feedback">
              Please provide the last name.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-3 gy-2 gx-3 align-items-start mb-2">
          <div class="col-12">
            <label for="Suffix" class="form-label">Suffix</label>
            <input type="text" id="Suffix" formControlName="Suffix" class="form-control form-control-sm" aria-label="Suffix" maxlength="4" />
          </div>
          <div class="col-12">
            <label for="Title" class="form-label">Title</label>
            <input id="Title" type="text" formControlName="Title" class="form-control form-control-sm" aria-label="Title" maxlength="80" />
          </div>
        </div>
        <div class="row row-cols-lg-3 gy-2 gx-3 align-items-start mb-2">
          <div class="col-12">
            <label for="Badge" class="form-label">Badge Number</label>
            <input id="Badge" type="text" formControlName="Badge" class="form-control form-control-sm" aria-label="Badge" maxlength="80" />
          </div>
          <div class="col-12" formArrayName="ENESS_XREF_LEPartnersEmailAccounts">
            <div [formGroupName]="0">
              <label for="Email" class="form-label">Email</label>
              <input id="Email" type="text" formControlName="EmailAccount" class="form-control form-control-sm" aria-label="Email" maxlength="128" />
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">Phone number(s)</caption>
            <thead>
              <tr>
                <th scope="col">Phone number</th>
                <th scope="col">Type</th>
                <th scope="col"> Primary</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="ENESS_XREF_LEPartnersPhoneNumbers.controls.length == 0;else partnerphrows">
                <tr><td colspan="4">No phone numbers found.</td></tr>
              </ng-container>
              <ng-template #partnerphrows>
                <tr formArrayName="ENESS_XREF_LEPartnersPhoneNumbers" *ngFor="let phone of ENESS_XREF_LEPartnersPhoneNumbers.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <td>{{ phone.get('PhoneNumber').value | phoneNumberFormat }}</td>
                    <td>{{ phone.get('PhoneNumberType').value }} <ng-container *ngIf="!!phone.get('PhoneNumberOtherType').value">({{ phone.get('PhoneNumberOtherType').value }})</ng-container></td>
                    <td class="text-center">
                      <input type="radio" name="IsPrimary" formControlName="IsPrimary" [checked]="phone.get('IsPrimary').value == true" (change)="onSelectPrimaryPhoneNumber(i)" aria-label="Primary phone number" class="form-check-input" [value]="true" />
                      <div class="cross-validation-feedback w-auto" *ngIf="lePartnerInputForm.get('ENESS_XREF_LEPartnersPhoneNumbers').invalid">
                        Please indicate which is the primary phone number.
                      </div>
                    </td>
                    <td class="text-center">
                      <button type="button" (click)="removePhoneNumber(i)" aria-label="Delete phone number." class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button>
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" class="p-3">
                  <div class="row row-cols-lg-auto gy-2 gx-3 align-items-start font-size-sm" [formGroup]="phoneNumberFormGroup">
                    <div class="col-12">
                      <label for="PhoneNumber" class="form-label required-field">Phone number <small>(Format: (999) 999-9999)</small></label>
                      <p-inputMask inputId="PhoneNumber" [required]="true" formControlName="PhoneNumber" mask="(999) 999-9999" styleClass="form-control form-control-sm" [ariaRequired]="true" [maxlength]="80"></p-inputMask>
                      <div class="invalid-feedback">
                        Please enter a phone number.
                      </div>
                    </div>
                    <div class="col-12">
                      <label for="PhoneNumberTypeID" class="form-label required-field">Type</label>
                      <select #phoneTypeDD id="PhoneNumberTypeID" formControlName="PhoneNumberTypeID" class="form-select form-select-sm" aria-required="true" required>
                        <option value="">Select a phone type</option>
                        <ng-container *ngIf="lookupService.phoneNumberTypes$ | async as phoneNumberTypes">
                          <option *ngFor="let phoneType of phoneNumberTypes" value="{{phoneType.PhoneNumberTypeID}}">{{ phoneType.PhoneNumberType }}</option>
                        </ng-container>
                      </select>
                      <div class="invalid-feedback">
                        Please select a phone number type.
                      </div>
                    </div>
                    <div class="col-12" [class.d-none]="phoneNumberFormGroup.get('PhoneNumberOtherType').disabled">
                      <label for="PhoneNumberOtherType" class="form-label required-field text-nowrap">Other type (80 chars max)</label>
                      <input id="PhoneNumberOtherType" type="text" formControlName="PhoneNumberOtherType" class="form-control form-control-sm" maxlength="80" aria-required="true" required />
                      <div class="invalid-feedback">
                        <div *ngIf="phoneNumberFormGroup.get('PhoneNumberOtherType').hasError('required')">Please specify other phone number type.</div>
                        <div *ngIf="phoneNumberFormGroup.get('PhoneNumberOtherType').hasError('maxLength')">The maximum length for Other phone number type is 80 characters.</div>
                      </div>
                    </div>
                    <div class="col-12 mt-lg-auto mt-2" [style.margin-bottom]="phoneNumberFormGroup.invalid ? 'calc((((1.5 * .875rem) + .5rem + 2px) + (1.5 * .875em)) / 2)' : '.25rem'">
                      <div class="form-check">
                        <input type="checkbox" id="IsPrimary" formControlName="IsPrimary" class="form-check-input" />
                        <label class="form-check-label" for="IsPrimary">Is primary?</label>
                      </div>
                    </div>
                  </div>
                  <div class="my-2">
                    <button type="button" [disabled]="phoneNumberFormGroup.invalid" (click)="insertPhoneNumber(phoneTypeDD.options[phoneTypeDD.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add phone number</button>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </form>
    </div>
  </div>
  <div class="my-3">
    <button type="button" [disabled]="!lePartnerInputForm.valid" (click)="onSaveLePartner()" class="btn btn-sm btn-active mb-2" label="Save LE Partner">Save LE Partner</button>
    <button type="button" (click)="onClose()" class="btn btn-sm btn-active mb-2 me-auto">Close</button>
  </div>
</section>
